import { createAsyncAction } from 'typesafe-actions';

import generateLogger from '@travel/logger';
import { noticeError } from '@travel/tracker';
import { isEmptyObject } from '@travel/utils';

import { fetchServiceConditions as fetchServiceConditionsApi } from './apis';
import { getServiceConditions } from './selectors';

import type { AppThunk } from 'typesafe-actions';
import type { ServiceConditionErrors, ServiceConditionResponse } from 'ServiceCondition-Types';

const logger = generateLogger();

export const fetchServiceConditionsAsync = createAsyncAction(
  'FETCH_SERVICE_CONDITIONS_REQUEST',
  'FETCH_SERVICE_CONDITIONS_SUCCESS',
  'FETCH_SERVICE_CONDITIONS_FAILURE',
)<undefined, ServiceConditionResponse, ServiceConditionErrors>();

export const fetchServiceConditions =
  (): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    try {
      dispatch(fetchServiceConditionsAsync.request());
      const existingConditions = getServiceConditions(getState());
      if (!isEmptyObject(existingConditions)) {
        dispatch(fetchServiceConditionsAsync.success(existingConditions));
        return;
      }
      const response = await fetchServiceConditionsApi(apiClient);
      dispatch(fetchServiceConditionsAsync.success(response));
    } catch (error) {
      dispatch(fetchServiceConditionsAsync.failure(error as ServiceConditionErrors));
      logger.error(error);
      noticeError('Service Conditions API error', error);
    }
  };
